import { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import logodev from "../assets/images/logodev.png";
import moon from "../assets/svg/moon.svg";
import sun from "../assets/svg/sun.svg";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <nav
      className="bg-gray-100 text-blue-600 font-bold p-4 sticky top-0 shadow-md text-lg
     dark:bg-[#010138]  dark:text-gray-200"
    >
      {" "}
      <div className="container mx-auto flex justify-between items-center">
        {" "}
        {/* Logo ou titre */}{" "}
        <NavLink to="/" className="text-xl font-bold ">
          <img src={logodev} alt="" width={60} height={60} />
        </NavLink>{" "}
        <div className=" flex flex-row space-x-3">
          <div className="flex items-center space-x-4 bg-blue-600 rounded-md dark:bg-blue-600 w-16">
            <button
              onClick={toggleTheme}
              className=" focus:outline-none flex flex-row space-x-2 justify-between px-1 
              items-center"
              aria-label="Toggle theme"
            >
              <div className=" text-white text-[12px] font-medium">theme</div>
              <div>
                <img
                  src={theme === "light" ? moon : sun}
                  alt=""
                  width={16}
                  height={16}
                  className=" "
                />{" "}
              </div>
            </button>
          </div>
          {/* Bouton Hamburger (visible uniquement sur mobile) */}{" "}
          <button
            className="md:hidden text-2xl focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {" "}
            {isOpen
              ? "✕"
              : "☰"} {/* Icône fermeture (X) ou menu (hamburger) */}{" "}
          </button>{" "}
        </div>
        {/* Menu de navigation */}{" "}
        <div
          className={`${
            isOpen ? "block" : "hidden"
          } md:flex md:space-x-1 absolute md:static top-20 left-0 w-full md:w-auto bg-gray-100 md:bg-transparent shadow-lg md:shadow-none
          p-4 md:p-0 dark:bg-[#010138] transition-all text-[18px] md:text-lg`}
        >
          {" "}
          <NavLink
            to="/"
            exact
            className="block p-3 rounded-md md:py-0 hover:text-white hover:bg-blue-600  dark:hover:text-white"
            activeClassName="text-blue-400 dark:text-blue-300"
            onClick={() => setIsOpen(false)}
          >
            {" "}
            Accueil{" "}
          </NavLink>{" "}
          <NavLink
            to="/about"
            className="block p-3 rounded-md md:py-0 hover:text-white hover:bg-blue-600   dark:hover:text-white"
            activeClassName="text-blue-400 dark:text-blue-300"
            onClick={() => setIsOpen(false)}
          >
            {" "}
            À Propos{" "}
          </NavLink>{" "}
          <NavLink
            to="/services"
            className="block p-3 rounded-md md:py-0 hover:text-white hover:bg-blue-600  dark:hover:text-white"
            activeClassName="text-blue-400 dark:text-blue-300"
            onClick={() => setIsOpen(false)}
          >
            {" "}
            Services{" "}
          </NavLink>{" "}
          <NavLink
            to="/projects"
            className="block p-3 rounded-md md:py-0 hover:text-white hover:bg-blue-600  dark:hover:text-white"
            activeClassName="text-blue-400 dark:text-blue-300"
            onClick={() => setIsOpen(false)}
          >
            {" "}
            Projets{" "}
          </NavLink>{" "}
          <NavLink
            to="/contact"
            className="block p-3 rounded-md md:py-0 hover:text-white hover:bg-blue-600  dark:hover:text-white"
            activeClassName="text-blue-400 dark:text-blue-300"
            onClick={() => setIsOpen(false)}
          >
            {" "}
            Contact{" "}
          </NavLink>{" "}
        </div>{" "}
      </div>{" "}
    </nav>
  );
}
export default Navbar;
